import styled, { keyframes } from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

const slideUp = keyframes`
  from { opacity: 0; transform: translate(-50%, 16px); }
  to { opacity: 1; transform: translate(-50%, 0); }
`;

export const Toast = styled.div`
  position: fixed;
  left: 50%;
  bottom: 20px;
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: calc(100vw - 32px);
  padding: 10px 10px 10px 18px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 700;
  color: #FFFFFF;
  background: ${colors.brandDark};
  box-shadow: ${shadow.raised};
  transform: translateX(-50%);
  animation: ${slideUp} 0.3s ease-out;
`;

export const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 800;
  color: ${colors.brandDark};
  background: ${colors.amber};
  cursor: pointer;
`;
